import { LocalShipping } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";
import ModalAsnDetails from "../Modal/ModalAsnDetails";
import { AdvancedShippingNotice } from "@/common/AdvancedShippingNotice";
import { Transfer } from "@/common/Transfer";

export type AsnDetailsModalProps = {
	asns?: AdvancedShippingNotice[];
	isModalAsnDetailsOpen?: boolean;
	onAsnDetailsModalOpen?: () => void;
	onAsnDetailsModalClose?: () => void;
};

export type AsnButtonProps = {
	isOpen: boolean;
	asns: AdvancedShippingNotice[];
	transfer?: Transfer;
	fromLocationId?: string;
	fromLocationName?: string;
	toLocationId?: string;
	toLocationName?: string;
	onAsnDetailsModalOpen: () => void;
	onAsnDetailsModalClose: () => void;
	compact?: boolean;
};

export default function AsnButton(props: AsnButtonProps) {
	const {
		isOpen,
		asns,
		transfer,
		fromLocationId,
		fromLocationName,
		toLocationId,
		toLocationName,
		onAsnDetailsModalOpen,
		onAsnDetailsModalClose,
		compact = false,
	} = props;

	return (
		<>
			<IconButton
				onClick={onAsnDetailsModalOpen}
				sx={{
					marginRight: 1,
					marginTop: "2px",
					flexShrink: 0,
					padding: "4px",
					...(compact && {
						marginBottom: "4px",
						paddingLeft: 0,
						paddingRight: { xs: "4px", sm: "8px" },
						paddingTop: { xs: "4px", sm: "8px" },
						paddingBottom: { xs: "4px", sm: "8px" },
					}),
				}}
			>
				<LocalShipping
					fontSize={compact ? undefined : "medium"}
					sx={compact ? { fontSize: { xs: "1.25rem", sm: "1.5rem" } } : undefined}
				/>
				<Typography
					variant={compact ? "body2" : "subtitle1"}
					sx={{
						fontWeight: "bold",
						paddingLeft: compact ? { xs: "4px", sm: "8px" } : "4px",
						...(compact && { fontSize: { xs: "0.875rem", sm: "1rem" } }),
					}}
				>
					ASNs
				</Typography>
			</IconButton>
			<ModalAsnDetails
				isOpen={isOpen}
				asns={asns}
				transfer={transfer}
				fromLocationId={fromLocationId}
				fromLocationName={fromLocationName}
				toLocationId={toLocationId}
				toLocationName={toLocationName}
				onAsnDetailsModalClose={onAsnDetailsModalClose}
			/>
		</>
	);
}
